// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css, } from 'emotion';
import styled from '@emotion/styled'
import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-date-picker';
import { useSelector, useDispatch } from 'react-redux'
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { setSearch, setFilter } from '../actions';
import { COLOR } from '../const'
import { getOptionOrders, getOptionRoute, getOptionParcel } from '../api/githubAPI'
import ReactTags from 'react-tag-autocomplete'


import DateRangePicker from 'react-daterange-picker'
import 'react-daterange-picker/dist/css/react-calendar.css' // For some basic styling. (OPTIONAL)
import ModalRemark from './ModalRemark'

const moment = extendMoment(Moment);

export interface ISTag { id: number, name: string, disabled?: boolean }

const BarSearch = ({ textSearch, order }: { textSearch: string, order: number | undefined }) => {
  const [keyword, setKeyword] = useState('');
  const ltdate = new Date();
  ltdate.setHours(1, 0, 0, 0);
  const start = new Date();
  start.setHours(1, 0, 0, 0);

  const [date, setDate] = useState(ltdate);

  const stdate = new Date();
  stdate.setHours(1, 0, 0, 0);
  const str_gtdate = stdate.setDate(start.getDate() - 1);
  const end = new Date(str_gtdate);
  const defDate = moment.range(start, end)

  const wrapperRef = useRef(null);
  useOutsideDateRange(wrapperRef);

  const [dateRange, setDateRange] = useState(defDate);
  const [showRange, setRange] = useState(false);
  const [showfilter, steshowfilter] = useState(false);
  const [sort, setSort] = useState(-1);
  const [skip, setSkip] = useState(0);
  const [showRemark, setshowRemark] = useState(false);
  const [sender, setSender] = useState<[ISTag] | []>([]);
  const [status, setStatus] = useState<[ISTag] | []>([]);
  const [type, setType] = useState<[ISTag] | []>([]);
  const [packge, setPackge] = useState<[ISTag] | []>([]);
  const [service, setService] = useState<[ISTag] | []>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [suggestions_sender, setSuggestions_sender] = useState<[ISTag] | []>([]);
  const [suggestions_status, setSuggestions_status] = useState<[ISTag] | []>([]);

  const [suggestions_type, setSuggestions_type] = useState<[ISTag] | []>([]);
  const [suggestions_packge, setSuggestions_packge] = useState<[ISTag] | []>([]);
  const [suggestions_service, setSuggestions_service] = useState<[ISTag] | []>([]);



  // suggestions_sender


  const count = useSelector((state: any) => state.Search.count)
  // const count = useSelector((state: any) => state.Search.count)
  const def_packge: any = [{ id: 0, name: "ไม่มีกล่อง" }, { id: 1, name: "มีกล่อง" }]
  const def_type: any = [{ id: 0, name: "Parcel" }, { id: 1, name: "Route" }]

  // let suggestions_sender = [
  //   { id: 1, name: "Apples" },
  //   { id: 2, name: "Pears" },
  //   { id: 3, name: "Bananas" },
  //   { id: 4, name: "Mangos" },
  //   { id: 5, name: "Lemons" },
  //   { id: 6, name: "Apricots" },
  //   { id: 7, name: "Bananas" }
  // ]
  // const suggestions_status = [
  //   { id: 1, name: "Apples" },
  //   { id: 2, name: "Pears" },
  //   { id: 3, name: "Bananas" },
  //   { id: 4, name: "Mangos" },
  //   { id: 5, name: "Lemons" },
  //   { id: 6, name: "Apricots" },
  //   { id: 7, name: "Bananas" }
  // ]
  // const suggestions_type: Array<ISTag> = []
  // const suggestions_packge: Array<ISTag> = []
  // const suggestions_service: Array<ISTag> = []

  async function fetchEverything() {
    async function fetchFilter() {

      if (order === 0) {
        const FilterResult: any = await getOptionOrders(date)
        // console.log(FilterResult.senders)
        setSuggestions_sender(FilterResult.senders)

        setSuggestions_type(def_type)
        setSuggestions_packge(def_packge)

        setSuggestions_status(FilterResult.status)
      }
      if (order === 1) {
        const FilterResult: any = await getOptionRoute(date)
        console.log(FilterResult.status)
        setSuggestions_sender(FilterResult.senders)
        setSuggestions_status(FilterResult.status)
        setSuggestions_packge(def_packge)
        const def_service: any = [{ id: 0, name: "SKOOTAR" }, { id: 1, name: "LALAMOVE" }]
        setSuggestions_service(def_service)
      }
      if (order === 2) {
        const FilterResult: any = await getOptionParcel(date)
        console.log(FilterResult.senders)
        setSuggestions_sender(FilterResult.senders)
        setSuggestions_status(FilterResult.status)
        setSuggestions_service(FilterResult.services)
      }

    }

    try {
      await Promise.all([fetchFilter()])
      // setIssuesError(null)
    } catch (err) {
      console.error(err)
      // setIssuesError(err)
    } finally {
      setIsLoading(true)
    }
  }

  useEffect(() => {
    setIsLoading(false)
    // fetchEverything()
  }, [date])

  useEffect(() => {
    if (!isLoading) {
      fetchEverything();
    }
  }, [isLoading])


  useEffect(() => {
    // fetchEverything()
  }, [suggestions_sender])

  const dispatch = useDispatch();
  const onChangeDate = (event: any) => {
    if (order === 2) {
      console.log(event)
      setDateRange(moment.range(event.end, event.start))
      setRange(false)
    } else {
      setDate(event);
    }

    setSkip(0);
  }



  useEffect(() => {
    if (order === 2) {
      dispatch(setSearch(keyword, dateRange, sort, skip, count));
    } else {
      dispatch(setSearch(keyword, date, sort, skip, count));
    }
  });

  // const onChangeDateRange = (event: any) => { setDate(event); setSkip(0); }
  // useEffect(() => {
  //   dispatch(setSearch(keyword, date, sort, skip, count));
  //   ;
  // });


  useEffect(() => {
    let dp_sender: any = []
    sender.forEach(e => {
      dp_sender.push(e.name)
    });
    let dp_status: any = []
    status.forEach(e => {
      dp_status.push(e.name)
    });
    let dp_service: any = []
    service.forEach(e => {
      dp_service.push(e.name)
    });
    let dp_packge: any = []
    packge.forEach(e => {
      dp_packge.push(e.name)
    });
    let dp_type: any = []
    type.forEach(e => {
      dp_type.push(e.name)
    });
    // console.log('dp_sender', dp_sender, dp_status, dp_service)
    dispatch(setFilter(dp_sender, dp_status, dp_service, dp_packge, dp_type));
  });




  const handleDelete = (i: number, thisState: any, setState: any, thisSugges: [ISTag] | [], setSugges: any): void => {
    const tags = thisState.slice(0)
    const Suggestions = tags.splice(i, 1)
    // console.log(Suggestions)
    const tmp: any = thisSugges.concat(Suggestions)
    tmp.sort((a: any, b: any) => {
      if (a.name > b.name) {
        return 1;
      }
      if (b.name > a.name) {
        return -1;
      }
      return 0;
    })
    setSugges(tmp)
    setState(tags)
  }

  const handleAddition = (s: any, thisState: any, setState: any, thisSugges: [ISTag] | [], setSugges: any): void => {
    const tags = [].concat(thisState, s)
    const Suggestions: any = thisSugges.filter((e) => {
      console.log(e.name, s)
      return e.name === s.name ? false : true
    })
    setSugges(Suggestions)
    setState(tags)
  }


  const handleClear = (thisState: any, setState: any, thisSugges: [ISTag] | [], setSugges: any): void => {
    const tags = thisState
    // console.log(Suggestions)
    const tmp: any = thisSugges.concat(tags)
    tmp.sort((a: any, b: any) => {
      if (a.name > b.name) {
        return 1;
      }
      if (b.name > a.name) {
        return -1;
      }
      return 0;
    })
    setSugges(tmp)
    setState([])
  }

  function useOutsideDateRange(ref: any) {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setRange(false)
      }
    }

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
    });
  }

  const ReactTags_css =
  {
    root: 'react-tags',
    rootFocused: 'is-focused',
    selected: 'react-tags__selected',
    selectedTag: 'react-tags__selected-tag',
    selectedTagName: 'react-tags__selected-tag-name',
    search: 'react-tags__search',
    searchInput: 'react-tags__search-input',
    suggestions: 'react-tags__suggestions',
    suggestionActive: 'is-active',
    suggestionDisabled: 'is-disabled'
  }

  const handleRemark = () => {
    setshowRemark(false)
  }

  const pangNumber = `${(skip) + 1}-${count < ((skip + 1) + 50) ? count : (skip) + 50}`;
  const nextpage = ((((skip + 1) + 50) - count) > 0) ? true : false
  const iconRemark = require('../images/comment.png')
  return (
    <>
      <div className={styles.navBar}>
        <div className={styles.itemLeft}>
          <Filter show={showfilter} onClick={() => steshowfilter(!showfilter)}> <i className="icon-filter" /></Filter>
          {order === 2 ? <div
            ref={wrapperRef}
          // onFocus={()=>{setRange(false)}}
          // onBlur={()=>{setRange(false)}}
          >
            <div className={styles.wrapInput}>
              <div className={styles.iconInput}>
                <i className="icon-calendar" onClick={() => { setRange(true) }} />
              </div>
              <input
                value={`${moment(dateRange.start).format('DD/MM/YYYY')}-${moment(dateRange.end).format('DD/MM/YYYY')}`}
                onClick={() => { setRange(true) }}

              />
            </div>
            {showRange ? <div className={styles.dateRangePicker}>
              <DateRangePicker
                className={styles.reactDatePicker}
                onSelect={onChangeDate}
                value={dateRange}
              /></div> : null}
          </div>

            :
            <DatePicker
              className={styles.reactDatePicker}
              onChange={onChangeDate}
              format="dd/MM/y"
              value={date}
            />}
          <input
            className={styles.inputSearch}
            type="text"
            onChange={e => setKeyword(e.target.value)}
            // onKeyDown={e => {
            //   if (e.key === 'Enter') {
            //     dispatch(setSearch(keyword,date,sort,skip));
            //   }
            // }}
            placeholder={textSearch}
            value={keyword}
          />

        </div>
        <div className={styles.itemRight}>
          <img className={styles.iconRemark} src={iconRemark} onClick={() => { setshowRemark(true) }} />

          <select className={styles.input} value={sort} onChange={e => setSort(parseInt(e.target.value))}>
            <option value={-1}>Lastest</option>
            <option value={1}>Oldest</option>
          </select>

          <div className={styles.pagination}>
            <a href="#" className={skip === 0 ? styles.disable : ''} onClick={() => setSkip(skip - 50)}>❮</a>
            <div className={styles.paginationText}> {count === 0 ? 0 : pangNumber}</div>
            <div className={styles.paginationTextSmall}> of </div>
            <div className={styles.paginationTextSmall}>{count}</div>
            <a href="#" className={nextpage ? styles.disable : ''} onClick={() => setSkip(skip + 50)}>❯</a>
          </div>
        </div>

      </div>
      <FilterStyled show={showfilter}>
        <div className={styles.filterlable}>
          {/* <span>Sender</span> */}
          <ReactTags
            classNames={ReactTags_css}
            autoresize={false}
            minQueryLength={0}
            maxSuggestionsLength={20}
            tags={sender}
            placeholder="Sender"
            suggestions={suggestions_sender}
            handleDelete={(e) => handleDelete(e, sender, setSender, suggestions_sender, setSuggestions_sender)}
            handleAddition={(e) => handleAddition(e, sender, setSender, suggestions_sender, setSuggestions_sender)} />

          <Clearall show={sender.length > 0} onClick={(e) => handleClear(sender, setSender, suggestions_sender, setSuggestions_sender)} >Clear All</Clearall>
        </div>
        {order === 0 ? null : <div className={styles.filterlable}>
          {/* <span>status</span> */}
          <ReactTags
            classNames={ReactTags_css}
            autoresize={false}
            minQueryLength={0}
            tags={status}
            placeholder="status"
            suggestions={suggestions_status}
            handleDelete={(e) => handleDelete(e, status, setStatus, suggestions_status, setSuggestions_status)}
            handleAddition={(e) => handleAddition(e, status, setStatus, suggestions_status, setSuggestions_status)} />

          <Clearall show={status.length > 0} onClick={(e) => handleClear(status, setStatus, suggestions_status, setSuggestions_status)} >Clear All</Clearall>
        </div>}
        {order === 0 ? <div className={styles.filterlable}>
          {/* <span>Type</span> */}
          <ReactTags
            classNames={ReactTags_css}
            autoresize={false}
            minQueryLength={0}
            tags={type}
            placeholder="type"
            suggestions={suggestions_type}
            handleDelete={(e) => handleDelete(e, type, setType, suggestions_type, setSuggestions_type)}
            handleAddition={(e) => handleAddition(e, type, setType, suggestions_type, setSuggestions_type)} />
          <Clearall show={type.length > 0} onClick={(e) => handleClear(type, setType, suggestions_type, setSuggestions_type)} >Clear All</Clearall>
        </div> : null}
        {order !== 2 ? <div className={styles.filterlable}>
          {/* <span>Packge</span> */}
          <ReactTags
            classNames={ReactTags_css}
            autoresize={false}
            minQueryLength={0}
            tags={packge}
            placeholder="package"
            suggestions={suggestions_packge}
            handleDelete={(e) => handleDelete(e, packge, setPackge, suggestions_packge, setSuggestions_packge)}
            handleAddition={(e) => handleAddition(e, packge, setPackge, suggestions_packge, setSuggestions_packge)} />
          <Clearall show={packge.length > 0} onClick={(e) => handleClear(packge, setPackge, suggestions_packge, setSuggestions_packge)} >Clear All</Clearall>
        </div> : null}
        {order === 0 ? null : <div className={styles.filterlable}>
          {/* <span>Service</span> */}
          <ReactTags
            classNames={ReactTags_css}
            autoresize={false}
            minQueryLength={0}
            tags={service}
            placeholder="service"
            suggestions={suggestions_service}
            handleDelete={(e) => handleDelete(e, service, setService, suggestions_service, setSuggestions_service)}
            handleAddition={(e) => handleAddition(e, service, setService, suggestions_service, setSuggestions_service)} />
          <Clearall show={service.length > 0} onClick={(e) => handleClear(service, setService, suggestions_service, setSuggestions_service)} >Clear All</Clearall>
        </div>}
      </FilterStyled>
      <ModalRemark show={showRemark} close={handleRemark} />
    </>

  );
}


const styles = {
  navBar: css`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 30px 0;
    align-items: center;
  `,
  itemRight: css`
    width: 50%;
    display: flex;
    justify-content: flex-end;
  `,
  itemLeft: css`
  width: 50%;
  display: flex;
  justify-content: flex-start;
`,
iconRemark:css`
  position: absolute;
  top: 0px;
`,
  inputSearch: css`
    margin-left:30px;
    width: 206px;
    display: block;
    padding: 5px 6px;
    font-size: 14px;
    font-weight: 400;
    line-height:14px;
    color: ${COLOR['DARK_2']};
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid ${COLOR['BLUE_DARK_OPA_1']};
    border-radius: 7px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    box-sizing: border-box;
    &:focus{
      box-shadow: none;
      outline: none;
    }
    &::-webkit-input-placeholder{
      color: ${COLOR['PLACEHOLDER']};
    }
    &:-ms-input-placeholder {
      color: ${COLOR['PLACEHOLDER']};
    }
    &::placeholder {
      color: ${COLOR['PLACEHOLDER']};
    }
  `,
  input: css`
    margin-right:30px;
    width: 206px;
    display: block;
    padding: 5px 6px;
    font-size: 14px;
    font-weight: 400;
    line-height:14px;
    color: ${COLOR['DARK_2']};
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid ${COLOR['BLUE_DARK_OPA_1']};
    border-radius: 7px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    box-sizing: border-box;
    &:focus{
      box-shadow: none;
      outline: none;
    }
    &::-webkit-input-placeholder{
      color: ${COLOR['PLACEHOLDER']};
    }
    &:-ms-input-placeholder {
      color: ${COLOR['PLACEHOLDER']};
    }
    &::placeholder {
      color: ${COLOR['PLACEHOLDER']};
    }
  `,
  filterlable: css`
    width: 320px;
    color: ${COLOR['DARK_2']};
    position: relative;
    padding-right: 15px;
    span {
      font-size: 14px;
      font-weight: 800;
      margin-right:10px;
    };
    select {
      width: 200px;
    };
    input {
      width: 200px;
    };
  `,
  dateRangePicker: css`
    position: absolute;
    width: 315px;
    left: 96px;
    z-index: 999990999;
    background-color: #ffffff;
    padding: 15px;
    border: 1px solid rgba(68,73,102,0.1);
    border-radius: 13px;
    color: ${COLOR['BLUE_DARK']};
    .DateRangePicker{
      width:100%;
      margin-bottom:0;
      .DateRangePicker__PaginationArrow--previous{
        left:0;
        top:1px;
        font-size: 24px;
        color: ${COLOR['BLUE_DARK']};
        :before{
          font-family: "fontello";
          content:"‹"
        }
        :hover{
          background-color: ${COLOR['YELLOW_1']};
        }
      }
      .DateRangePicker__PaginationArrow--next{
        right:0;
        top:1px;
        font-size: 24px;
        color: ${COLOR['BLUE_DARK']};
        :before{
          font-family: "fontello";
          content:"›"
        }
        :hover{
          background-color: ${COLOR['YELLOW_1']};
        }
      }
      .DateRangePicker__PaginationArrowIcon--next{
        display: none;
      }
      .DateRangePicker__PaginationArrowIcon--previous{
        display: none;
      }
      .DateRangePicker__MonthHeader{
        width:100%;
        background-color: ${COLOR['YELLOW_1']};
        border-radius: 13px;
        color: ${COLOR['BLUE_DARK']};
        font-size: 18px;
        font-weight: normal;
        padding: 4px 0;
      }
      .DateRangePicker__Month{
        margin:0;
        width:100%;
      }
      .DateRangePicker__MonthDates{
        border-bottom:0;
        .DateRangePicker__Weekdays{
          border-bottom:0;
          .DateRangePicker__WeekdayHeading abbr[title]{
            color: ${COLOR['BLUE_DARK']};
          }
        }
        .DateRangePicker__Date--weekend{
          background-color: ${COLOR['WHITE']};
        }
        .DateRangePicker__Date{
          border: 0;
          color: ${COLOR['BLUE_DARK']};
        }
      }
      .DateRangePicker__CalendarSelection--is-pending{
        background-color:${COLOR['YELLOW_1']};
      }
      .DateRangePicker__CalendarHighlighted--single{
        background-color:'#000;
      }
      .DateRangePicker__CalendarSelection{
        background-color:${COLOR['YELLOW_1']};
        border: 1px solid ${COLOR['YELLOW_1']};
      }
      .DateRangePicker__Date--is-highlighted{
        border:0 !important;
      }
    }
  `,
  reactDatePicker: css`
  width: 206px;
  display: block;
  .react-date-picker__wrapper{
    width: 100%;
    position: relative;
    padding: 5px 6px 5px 35px;
    font-size: 14px;
    font-weight: 400;
    line-height:14px;
    color: ${COLOR['DARK_2']};
    background-clip: padding-box;
    border: 1px solid ${COLOR['BLUE_DARK_OPA_1']};
    border-radius: 7px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .react-date-picker__inputGroup__input{
    color: ${COLOR['DARK_2']};
  }
  .react-date-picker__calendar-button{
    background-color: ${COLOR['YELLOW_1']};
    color: ${COLOR['BLUE_DARK']};
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    position: absolute;
    left: 0;
    top: 0;
    &:focus{
      box-shadow: none;
      outline: none;
    }
  }
  .react-date-picker__button svg{
    display: none !important;
  }
  .react-date-picker__clear-button{
    display: none !important;
  }
  .react-date-picker__inputGroup__input{
    &:focus{
      box-shadow: none;
      outline: none;
      background-color: #ffffff;
    }
  }
  .react-date-picker__calendar{
    width: 343px;
    z-index: 9999;
  }
  .react-calendar{
    background-color: #ffffff;
    padding: 15px;
    border: 1px solid ${COLOR['BLUE_DARK_OPA_1']};
    border-radius: 13px;
  }
  .react-calendar__navigation{
    background-color:${COLOR['YELLOW_1']};
    border-radius: 13px;
    color:${COLOR['BLUE_DARK']};
  }
  .react-calendar__navigation button{
    font-size: 18px !important;
    color:${COLOR['BLUE_DARK']} !important;
  }
 .react-calendar__navigation__prev2-button{
  display: none !important;
 }
 
 .react-calendar__navigation__next2-button{
  display: none !important;
 }
 .react-calendar__navigation__label{
  pointer-events: none;
 }
 .react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus{
  background-color:${COLOR['YELLOW_1']};
  border-radius: 13px;
 }
 .react-calendar__tile:enabled:hover, .react-calendar__tile:enabled:focus{
  background-color:${COLOR['YELLOW_1']};
  border-radius: 3px;
 }
 .react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled:focus{
  background-color:${COLOR['YELLOW_1']};
  border-radius: 3px;
 }
 .react-calendar__month-view__weekdays{
  color:${COLOR['BLUE_DARK']};
  abbr{
    text-decoration: none !important;
  }
 }
 .react-calendar button{
  color:${COLOR['DARK_1']};
  font-size: 14px;
 }
 .react-calendar__tile--active{
  background-color:${COLOR['YELLOW_1']};
  border-radius: 3px;
 }
 .DateRangePicker__CalendarHighlight--single {
  border: 1px solid #FDB513;
}
`,
  pagination: css`
    float: right;
    display: inline-block;
    
    div {
        position: relative;
        color: #242D31;
        float: left;
        height: 30px;
        top: 12px;
        font-size:12px;
        padding:0 5px;
      }
    a {
        float: left;
        padding: 5px 10px;
        text-decoration: none;
        transition: background-color .3s;
        border: 1px solid ${COLOR['BLUE_DARK_OPA_1']};
        border-radius: 5px;
        color:${COLOR['DARK_1']};
        background-color: ${COLOR['BLUE_DARK_OPA_1']};
        &:hover{
          color: ${COLOR['YELLOW_1']};
        }
      }
      
    
  `,
  paginationText: css`
    font-size:18px !important; 
    top:8px !important;
    color:${COLOR['DARK_1']};
  `,
  paginationTextSmall: css`
  font-size:12px !important; 
  top:12px !important;
  color:${COLOR['DARK_2']};
  `,
  disable: css`
  pointer-events: none;
  `,
  wrapInput: css`
    width: 206px;
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    color: ${COLOR['BLUE_DARK']};
    background-color: ${COLOR['WHITE']};
    background-clip: padding-box;
    border: 1px solid rgba(68,73,102,0.1);
    border-radius: 7px;
    -webkit-transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    input{
    color: ${COLOR['DARK_2']};
    padding: 5px 6px;
    width: 100%;
    -webkit-transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
    box-sizing: border-box;
    border: 0;
    border-radius: 7px;
    font-size: 14px;
    :focus{
      box-shadow: none;
      outline: none;
    }
    }
`,
  iconInput: css`
    padding: 5px;
    border-color: transparent;
    cursor: pointer;
    background-color: ${COLOR['YELLOW_1']};
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
   i{
    color: ${COLOR['DARK']};
    font-size: 20px;
   }
`,

};

type StyledComponentProps = {
  show: boolean
}

const Clearall = styled('button') <StyledComponentProps>`
display:${props => (props.show === true) ? 'inline-block' : 'none'};
position: absolute;
bottom: 30px;
right: 20px;
color:${COLOR['PLACEHOLDER']};
padding: 5px;
z-index: 99;
  font-weight: 400;
  color: #FDB513;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font-size: 14px;
}
`;

const Filter = styled('button') <StyledComponentProps>`
margin-right: 30px;
text-align: center;
padding: 5px 6px;
font-size: 14px;
color:${props => (props.show === true) ? COLOR['YELLOW_1'] : COLOR['BLUE_DARK']};
background: ${props => (props.show === true) ? COLOR['BLUE_DARK'] : COLOR['YELLOW_1']};
border-radius: 7px;
`;

const FilterStyled = styled('div') <StyledComponentProps>`
width: 100%;
display: flex;
flex-direction: row;
justify-content: start;
padding: 0px 0px 30px 0;
display: ${props => (props.show === true) ? 'display' : 'none'};
`;


export default BarSearch;
